<template lang="pug">
.error404Page
  .imageWrapper
    ui-image.image(
      image-url="assets/images/errors/404.svg"
      background-size="contain"
    )
  .title Ой! Произошла ошибка.
  ui-button.back(
    :withArrow="false"
    @click="$router.go(-1)"
  ) Назад
</template>

<script>
export default {
  data () {
    return {
      bgColor: null
    }
  },
  mounted () {
    this.bgColor = document.querySelector('.content').style.backgroundColor
    document.querySelector('.content').style.backgroundColor = '#094DB3'
  },
  unmounted () {
    document.querySelector('.content').style.backgroundColor = this.bgColor
  }
}
</script>

<style lang="sass" scoped>
.error404Page
  height: 100%
  display: flex
  flex-flow: column
  align-items: center
  justify-content: center

  > .imageWrapper
    width: 110*$u
    height: 92*$u
    margin-bottom: 1*$u
    @media (max-width: $mobileWidth)
      width: 74*$u
      height: 62*$u

  > .title
    @include font('t16-medium')
    color: $cWhite
    margin-bottom: 6*$u

  > .back
    width: 27.5*$u
    color: $cBlue
    background-color: $cWhite
</style>
